import { render, staticRenderFns } from "./AppAlertIcon.vue?vue&type=template&id=5b946190&scoped=true&"
import script from "./AppAlertIcon.vue?vue&type=script&lang=ts&"
export * from "./AppAlertIcon.vue?vue&type=script&lang=ts&"
import style0 from "./AppAlertIcon.vue?vue&type=style&index=0&id=5b946190&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b946190",
  null
  
)

export default component.exports